import { Badge, Text } from "@mantine/core";
import { createColumnHelper } from "@tanstack/react-table";
import { getClientLabel, getStatusColor } from "./helper";
import moment from "moment";
// Import directly, not via the core/components barrel: the barrel pulls in
// modules that read utils/helper at load time, and helper imports this file.
import DateDisplay from "core/components/dateDisplay/DateDisplay";

export const AppConstants = {
  inputVariant: "default",
  defaultPaginationSize: 100,
  ICON_STROKE_WIDTH: 2,
  ICON_SIZE: 18,
  CACHE_DELAY: 600000,
  CACHE_DELAY_LONG: 3600000,
};

export const SampleActions = {
  BUILD_OUTFIT: "buildoutfit",
};
export const SessionActions = {
  BUILD_OUTFIT: "buildoutfit",
  CREATE_SESSION_FROM_SAMPLES: "createSessionFromSamples",
  ASSIGN_SAMPLES_TO_SESSION: "assignSamplesToSession",
  ASSIGN_STYLEGUIDE: "assignStyleGuide",
  REMOVE_STYLEGUIDE: "removeStyleGuide",
  ASSIGN_SAMPLE: "sessionAssignSample",
  ASSIGN_TALENT_TO_SAMPLES: "assignTalentToSamples",
  REMOVE_SAMPLE: "sessionRemoveSample",
  ASSIGN_CAPTURES_TO_SAMPLES: "sessionAssignCapturesToSamples",
  DOWNLOAD_PDF_STUB: "sessionDownloadPDFStub",
  ARCHIVE: "sessionArchive",
};

export const GuideActions = {
  EDIT_GUIDE_CAT: "guideCategoryEdit",
  ADD_GUIDE_CAT_SHOT: "guideCategoryAddShot",
  UPDATE_GUIDE_CAT: "guideCategoryUpdate",
  REMOVE_GUIDE_CAT: "guideCategoryRemove",
  // EDIT_GUIDE:'buildoutfit'
};
export const SeasonActions = {
  // EDIT_GUIDE:'buildoutfit'
};

export const Exceptions = {
  SERIALISATION: "com.amazon.coral.service#SerializationException",
};

export const TaskActions = {
  EDIT_TASK: "editTask",
  DELETE_TASK: "deleteTask",
  ADD_TASK: "addTask",
};

export const TalentActions = {
  EDIT_TALENT: "editTalent",
  DELETE_TALENT: "deleteTalent",
  ADD_TALENT: "addTalent",
};

export const FrameActions = {
  ADD_SAMPLE: "add_sample",
  CLEAR_FRAME: "clear_frame",
  DELETE_FRAME: "delete_frame",
  CLOSE: "close",
  ADD_FRAME: "add_frame",
  SAMPLE_CLICK: "sample_click",
  DELETE_SAMPLE: "delete_sample",
  REPLACE_SAMPLE: "replace_sample",
};

export const SETTINGS = {
  TOOLBAR_HEIGHT: 60,
  TOOLBAR_WIDTH: 60,
};
export const ItemTypes = {
  FRAME: "frame",
  BOX: "box",
  CAPTURE: "capture",
};

export const ApprovalLayoutTypes = {
  GRID: "grid",
  SINGLE: "single",
  COMPARE: "compare",
  COMMENT: "comment",
};

export const ApprovalImageToolbarModes = {
  ZOOM_IN: "zoomIn",
  ZOOM_OUT: "zoomOut",
  ZOOM_RESET: "zoomReset",
  MARKUP: "markup",
};

export const FlagRating = {
  FLAG_SELECT: "1",
  FLAG_KILL: "2",
};

export const ComparisonOperators = {
  EQUAL: "equal",
  NOT_EQUAL: "not_equal",
  LESS_THAN: "less_than",
  GREATER_THAN: "greater_than",
  GREATER_THAN_OR_EQUAL: "greater_than_or_equal",
  LESS_THAN_OR_EQUAL: "less_than_or_equal",
};

export const DataFormats = {
  DATE_FORMAT: "MMMM Do YYYY",
  DATE_TIME_FORMAT: "MMM Do YYYY hh:mm A",
  DATE_FORMAT_SHORT: "DD/MM/YYYY",
  DATE_FORMAT_REST: "YYYY-MM-DD",
  TIMEZONE: "Australia/Melbourne",
  DATE_FORMAT_CREATE_PARSE: "YYYY-MM-DD-hh-mm-ss",
  TIME_FORMAT: "hh:mm A",
};

export const SessionTypes = {
  UNKOWN: "Session_Unknown",
};

export const ViewModes = {
  EDIT: "viewEdit",
  VIEW: "viewView",
  ADD: "viewAdd",
};
export const TreatmentTypes = {
  POST_PRODUCTION: { label: "Post Production", value: "Post Production" },
  RETOUCHING: { label: "Retouching", value: "Retouching" },
};

export const PaginationValues = [
  { value: 20, label: "Show 20" },
  { value: 50, label: "Show 50" },
  { value: 80, label: "Show 80" },
  { value: 100, label: "Show 100" },
];

export const APP_ENV =
  process.env.NODE_ENV === "development" ? "development" : "production";
export const LOG_LEVEL = APP_ENV === "production" ? "warn" : "log";

export const ResponseCodes = {
  ABORT_ERROR: 20,
};
export const SHELL_TAB_BAR_HEIGHT = 65;

export const ObjectKeys = ["S", "N", "L"];

export const StatusTypes = {
  PENDING: "Pending",
  ASSIGNED: "Assigned",
  IN_APPROVAL: "In Approval",
  COMPLETE: "Complete",
  CANCELLED: "Cancelled",
};

export const StatusTypeArray = [
  StatusTypes.PENDING,
  StatusTypes.ASSIGNED,
  StatusTypes.IN_APPROVAL,
  StatusTypes.COMPLETE,
  StatusTypes.CANCELLED,
];

const colors = {
  Y50: "#70575A",
  B50: "#4C616D",
  G50: "#505050",
  P50: "#3F5654",
  N400A: "grey",
};

export const status_unassigned = {
  id: "0",
  name: "Unassigned",
  label: "Unassigned",
  value: "unassigned",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.Y50,
    hard: colors.N400A,
    primary: "grey",
  },
};

export const status_backlog = {
  id: "1",
  name: "Pending",
  label: "Pending",
  value: "pending",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.Y50,
    hard: colors.N400A,
    primary: "grey",
  },
};

export const status_selected = {
  id: "2",
  name: "Assigned",
  label: "Assigned",
  value: "assigned",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.G50,
    hard: colors.N400A,
    primary: "violet",
  },
};

export const status_progress = {
  id: "3",
  name: "In Approval",
  label: "In Approval",
  value: "inapproval",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.B50,
    hard: colors.N400A,
    primary: "blue",
  },
};

export const status_complete = {
  id: "4",
  name: "Complete",
  label: "Complete",
  value: "complete",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.P50,
    hard: colors.N400A,
    primary: "teal",
  },
};

export const status_canceled = {
  id: "5",
  name: "Cancelled",
  label: "Cancelled",
  value: "cancelled",
  url: "",
  avatarUrl: null,
  colors: {
    soft: colors.P50,
    hard: colors.N400A,
    primary: "red",
  },
};

export const statuss = [
  status_backlog,
  status_selected,
  status_progress,
  status_complete,
  status_canceled,
];

export const PHOTOSHOP_FILE_TYPES = ".psd,.jpg,.png";

export const colorThemes = [
  "light",
  "dark",
  "blue",
  "cyan",
  "gray",
  "indigo",
  "lime",
  "orange",
  "pink",
  "purple",
  "red",
  "teal",
  "yellow",
];

export const userRoles = [
  { label: "Sample Co-ordinator", value: "Sample Co-ordinator" },
  { label: "Art Director", value: "Art Director" },
  { label: "Producer", value: "Producer" },
  { label: "Photographer", value: "Photographer" },
  { label: "Retoucher", value: "Retoucher" },
  { label: "Stylist", value: "Stylist" },
];

export const shotChannels = [
  { label: "Packaging", value: "Packaging" },
  { label: "e-commerce", value: "e-commerce" },
  { label: "Social", value: "Social" },
  { label: "Campaign", value: "Campaign" },
];

export const shotTags = [
  { label: "Hero", value: "Hero" },
  { label: "Hover", value: "Hover" },
];

export const ScanStatusItems = [
  { label: "Pending", value: "PENDING" },
  { label: "Succeeded", value: "SUCCEEDED" },
  { label: "Failure", value: "FAILURE" },
  { label: "Abandoned", value: "ABANDONED" },
  { label: "Created", value: "CREATED" },
  { label: "Parsed", value: "PARSED" },
  { label: "Master record not found", value: "MASTER_NOT_FOUND" },
  { label: "A2 Record not found", value: "LOCAL_NOT_FOUND" },
];

export const ScanStatuses = {
  PENDING: { label: "Pending", value: "PENDING" },
  SUCCEEDED: { label: "Succeeded", value: "SUCCEEDED" },
  FAILURE: { label: "Failure", value: "FAILURE" },
  ABANDONED: { label: "Abandoned", value: "ABANDONED" },
  CREATED: { label: "Created", value: "CREATED" },
  PARSED: { label: "Parsed", value: "PARSED" },
  MASTER_NOT_FOUND: {
    label: "Master record not found",
    value: "MASTER_NOT_FOUND",
  },
  LOCAL_NOT_FOUND: { label: "A2 Record not found", value: "LOCAL_NOT_FOUND" },
};

export const Genders = [
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "-", value: " " },
];

export const dataViewSettings = {
  defaultPaginationSize: 100,
};

export const SampleGrades = [
  { label: "Satisfactory", value: "Satisfactory" },
  { label: "Damaged", value: "Damaged" },
];

export const ERROR_TYPES = {
  // Network Errors
  NETWORK_ERROR: "NETWORK_ERROR",
  CONNECTION_REFUSED: "CONNECTION_REFUSED",
  TIMEOUT: "REQUEST_TIMEOUT",

  // HTTP Status Code Errors
  BAD_REQUEST: "BAD_REQUEST",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  SERVER_ERROR: "INTERNAL_SERVER_ERROR",

  // Authentication Errors
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",

  // Validation Errors
  VALIDATION_ERROR: "VALIDATION_ERROR",
  UNPROCESSABLE_ENTITY: "UNPROCESSABLE_ENTITY",

  // Generic Errors
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR",
};

export const ERROR_MESSAGES = {
  [ERROR_TYPES.NETWORK_ERROR]: "Network connection failed",
  [ERROR_TYPES.UNAUTHORIZED]: "You are not authorized to access this resource",
  [ERROR_TYPES.NOT_FOUND]: "Requested resource was not found",
  [ERROR_TYPES.SERVER_ERROR]: "Internal server error occurred",
  [ERROR_TYPES.TOKEN_EXPIRED]: "Your session has expired",
};

// Inventory list columns, shared by every client. `show: false` columns are
// hidden by default (InventoryList reads meta.show into columnVisibility).
// Array fields (channels, sessions, distribution dates) are joined for display.
const INVENTORY_COLUMNS = (company) => [
  { Header: "Variation", accessor: "seasonSort", width: 150 },
  { Header: "Name", accessor: "name", width: 350 },
  { Header: "Sample Identifier", accessor: "SAMPLEIDENTIFIER", width: 200, show: true },
  { Header: "Style No", accessor: "STYLE NO", width: 150, show: true },
  { Header: "Barcode", accessor: "BARCODE", width: 150, show: true },  
  { Header: "Size", accessor: "size", width: 150, show: true },
  { Header: getClientLabel(company, "otbDate", "OTB Date"), accessor: "otb", width: 170, show: true },
  { Header: "Priority", accessor: "priority", width: 150, show: true },
  { Header: "Status", accessor: "derivedStatus", width: 170, show: true },
  { Header: "Dept", accessor: "dept", width: 150, show: true },
  { Header: "Dept Name", accessor: "deptName", width: 180, show: true },
  { Header: "Category", accessor: "productCategory", width: 180, show: true },
  { Header: "Sub Category", accessor: "productSubcategory", width: 180, show: true },
  { Header: "Created", accessor: "created", width: 150, show: true },
  { Header: "Origin", accessor: "origin", width: 150, show: true },
  { Header: "Location", accessor: "scanLocation", width: 180, show: true },
  { Header: "Sample Count", accessor: "sampleCount", width: 180, show: true },
  { Header: "Channels", accessor: "channels", width: 150, show: true },
  { Header: "Event", accessor: "seasonPart", width: 150, show: true },
  { Header: "Session Codes", accessor: "sessionCodes", width: 250, show: true },
  { Header: "Session Names", accessor: "sessionNames", width: 250, show: true },
  // { Header: "Session Ready Status", accessor: "SessionReadyStatus", width: 170, show: true },
  { Header: "Captured", accessor: "captured", width: 150, show: true },
  // { Header: "Client", accessor: "client", width: 150, show: true },
  { Header: "Colourway", accessor: "colourway", width: 150, show: true },
  { Header: "Found in Feed", accessor: "foundInFeed", width: 180, show: true },
  { Header: "Shoot Date", accessor: "shootDate", width: 150, show: true },
  { Header: "Task Count", accessor: "taskCount", width: 150, show: true },
  { Header: "Asset Count", accessor: "photographyCount", width: 150, show: true },
  { Header: "Distribution", accessor: "distributionDates", width: 150, show: true },
];

const inventoryCell = (accessor) => (info) => {
  const value = info.getValue();
  if (accessor === "derivedStatus") {
    return value ? (
      <Badge variant="light" color={getStatusColor(value)}>
        {value}
      </Badge>
    ) : (
      ""
    );
  }
  if (Array.isArray(value)) return value.join(", ");
  return value ?? "";
};

const buildInventoryColumns = (columnHelper, company) =>
  INVENTORY_COLUMNS(company).map(({ Header, accessor, width, show }) =>
    columnHelper.accessor(accessor, {
      header: Header,
      size: width,
      cell: inventoryCell(accessor),
      meta: { show },
    })
  );

export const getCompanyTableColumns = (clientCode, listName) => {
  const columnHelper = createColumnHelper();
  const CompanyTableColumns = {
    KMA: {
      wipStyles: [
        columnHelper.accessor("seasonSort", {
          header: "Keycode",
          // meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),

        // new cols
        // check stylenumber
        columnHelper.accessor("STYLE NO", {
          header: "Style Number",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("SAMPLEIDENTIFIER", {
          header: "Sample Identifier",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("BARCODE", {
          header: "Barcode",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        // end new cols

        columnHelper.accessor("Name", {
          header: "Item Description",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 300,
        }),

        columnHelper.accessor("Size", {
          header: "Size",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 80,
        }),
        //renamed
        columnHelper.accessor("Dept", {
          header: "Dept Number",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("DeptName", {
          header: "Dept Name",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),

        columnHelper.accessor("OTB", {
          header: CompanyFormats["KMA"]?.LABELS?.otbDate ?? "OTB Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("scanned", {
          header: "Date Received",
          meta: { show: true },
          size: 180,
          cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("shootDate", {
          header: "Shoot Date",
          meta: { show: true },
          size: 180,
          cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("status", {
          header: "Status",
          meta: { show: true },
          size: 120,
          cell: (info) => {
            // if(info.row.original.sessionCodes && info.row.original.sessionCodes.length){
            //   return <Badge variant="light" color="cyan">
            //       {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
            //       scheduled
            //       {/* </Moment> */}
            //     </Badge>
            // }else if(parseInt(info.getValue()) > 0){
            //   return <Badge variant="light" color="indigo">
            //   {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
            //   acquired
            //   {/* </Moment> */}
            // </Badge>
            // }else{
            //   return "";
            // }

            return info.getValue().length ? (
              <Badge variant="light" color={getStatusColor(info.getValue())}>
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {info.getValue()}
                {/* </Moment> */}
              </Badge>
            ) : (
              ""
            );
          },
        }),
        columnHelper.accessor("scanLocation", {
          header: "Scan Location",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("scanned", {
          header: "Scan Date",
          meta: { show: true },
          cell: (info) =>
            info.getValue() && info.getValue() !== "false"
              ? moment(info.getValue()).format(DataFormats.DATE_TIME_FORMAT)
              : "",
          size: 180,
        }),
      ],
      // DISTRIBUTION STYLES
      distributionStyles: [
        columnHelper.accessor("style", {
          header: "Keycode",
          // meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("stylenumber", {
          header: "Style Number",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("sampleIdentifier", {
          header: "Sample Identifier",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("barcode", {
          header: "Barcode",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),

        columnHelper.accessor("name", {
          header: "Item Description",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("sessionCode", {
          header: "Session",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("shootDate", {
          header: "Shoot Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("distributionDate", {
          header: "Distribution Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("dept", {
          header: "Dept Number",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("DeptName", {
          header: "Dept Name",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("Size", {
          header: "Size",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 80,
        }),
        columnHelper.accessor("otbDate", {
          header: CompanyFormats["KMA"]?.LABELS?.otbDate ?? "OTB Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
      ],
      productionStyles: [
        columnHelper.accessor("ssSort", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),

        columnHelper.accessor("ssPart", {
          header: "Session",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("name", {
          header: "Name",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("department", {
          header: "Department",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        // end new cols

        columnHelper.accessor("clientProdStatus", {
          header: "Status",
          cell: (info) => {
            var label = StudioStatusTypes[info.getValue()].label;

            return info.getValue()?.length ? (
              <Badge variant="light" color={getStatusColor(info.getValue())}>
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {label}
                {/* </Moment> */}
              </Badge>
            ) : (
              ""
            );
          },
          size: 300,
        }),
      ],
      postProductionStyles: [
        columnHelper.accessor("photoCode", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),

        // Task fields
        columnHelper.accessor("taskPart", {
          header: "Session",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("style", {
          header: "Style",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("seasonCode", {
          header: "Season",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("status", {
          header: "Status",
          cell: (info) => {
            const value = info.getValue();
            return value ? (
              <Badge variant="light" color={getStatusColor(value)}>
                {StudioStatusTypes[value.toUpperCase()].label}
              </Badge>
            ) : (
              ""
            );
          },
          size: 180,
        }),
        columnHelper.accessor("deadline", {
          header: "Deadline",
          cell: (info) => info.getValue(),
          size: 150,
        }),
      ],
      masters: [
        columnHelper.accessor("KEYCODE", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("STYLE NO", {
          header: "Style Number",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("SAMPLEIDENTIFIERS", {
          header: "Sample Identifiers",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("ITEM/STYLE DESCRIPTION", {
          header: "Item/Style Description",
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("BARCODE", {
          header: "Barcode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("SIZE", {
          header: "Size",
          cell: (info) => info.getValue(),
          size: 100,
        }),
        columnHelper.accessor("VENDOR", {
          header: "Vendor",
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor("DEPT", {
          header: "Dept",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("DEPT NAME", {
          header: "Dept Name",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("INSTORE", {
          header: "In Store",
          cell: (info) => info.getValue(),
          size: 120,
        }),
      ],
      mastersInfo: [
        columnHelper.accessor("apn", {
          header: "APN",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("dept", {
          header: "Department",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("deptName", {
          header: "Department Name",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("kmartKeycode", {
          header: "Kmart Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("modified", {
          header: "Modified",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("otb", {
          header: CompanyFormats["KMA"]?.LABELS?.otbDate ?? "OTB",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("productName", {
          header: "Product Name",
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("styleNumber", {
          header: "Style Number",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("variation", {
          header: "Variation",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("variationSize", {
          header: "Variation Size",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("version", {
          header: "Version",
          cell: (info) => info.getValue(),
          size: 180,
        }),
      ],
      inventories: buildInventoryColumns(columnHelper, "KMA"),
    },
    TAR: {
      wipStyles: [
        columnHelper.accessor("seasonSort", {
          header: "Style",
          // meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),

        columnHelper.accessor("Name", {
          header: "Name",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("Size", {
          header: "Size",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 80,
        }),
        columnHelper.accessor("Dept", {
          header: "Department",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("OTB", {
          header: "OTB Date",
          meta: { show: true },
          cell: (info) => {
            return info.getValue().length ? (
              <DateDisplay value={info.getValue()} />
            ) : (
              ""
            );
          },
        }),
        columnHelper.accessor("shootDate", {
          header: "Shoot Date",
          meta: { show: true },
          size: 180,
          cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("sessionCodes", {
          header: "Session",
          meta: { show: true },
          cell: (info) => {
            return info.getValue().map((val) => {
              // <Badge variant="light" color="cyan">
              return <Text>{val}</Text>;
              // </Badge>
            });
          },
          size: 180,
        }),
        columnHelper.accessor("status", {
          header: "Status",
          meta: { show: true },
          size: 120,
          cell: (info) => {
            // if(info.row.original.sessionCodes && info.row.original.sessionCodes.length){
            //   return <Badge variant="light" color="cyan">
            //       {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
            //       scheduled
            //       {/* </Moment> */}
            //     </Badge>
            // }else if(parseInt(info.getValue()) > 0){
            //   return <Badge variant="light" color="indigo">
            //   {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
            //   acquired
            //   {/* </Moment> */}
            // </Badge>
            // }else{
            //   return "";
            // }

            return info.getValue()?.length ? (
              <Badge variant="light" color={getStatusColor(info.getValue())}>
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {info.getValue()}
                {/* </Moment> */}
              </Badge>
            ) : (
              ""
            );
          },
        }),
        columnHelper.accessor("scanLocation", {
          header: "Scan Location",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("scanned", {
          header: "Scan Date",
          meta: { show: true },
          cell: (info) =>
            info.getValue() && info.getValue() !== "false"
              ? moment(info.getValue()).format(DataFormats.DATE_TIME_FORMAT)
              : "",
          size: 180,
        }),
      ],
      distributionStyles: [
        columnHelper.accessor("styleNumber", {
          header: "Style Number",
          // meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("name", {
          header: "Name",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("distributionDate", {
          header: "Distribution Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("dept", {
          header: "Department",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("otbDate", {
          header: CompanyFormats["TAR"]?.LABELS?.otbDate ?? "OTB Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("sessionCode", {
          header: "Session",
          meta: { show: true },
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("shootDate", {
          header: "Shoot Date",
          meta: { show: true },
          cell: (info) => info.getValue(),
          // size: 180,
        }),
      ],
      productionStyles: [
        columnHelper.accessor("ssSort", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),

        // new cols
        // check stylenumber
        columnHelper.accessor("ssPart", {
          header: "Session",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("name", {
          header: "Name",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("department", {
          header: "Department",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        // end new cols

        columnHelper.accessor("clientProdStatus", {
          header: "Status",
          cell: (info) => {
            var label = StudioStatusTypes[info.getValue()].label;

            return info.getValue()?.length ? (
              <Badge variant="light" color={getStatusColor(info.getValue())}>
                {/* <Moment format={DataFormats.DATE_TIME_FORMAT}> */}
                {label}
                {/* </Moment> */}
              </Badge>
            ) : (
              ""
            );
          },
          size: 300,
        }),
      ],
      postProductionStyles: [
        columnHelper.accessor("photoCode", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),

        // Task fields
        columnHelper.accessor("taskPart", {
          header: "Session",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("style", {
          header: "Style",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("seasonCode", {
          header: "Season",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        // columnHelper.accessor("guideId", {
        //   header: "Guide",
        //   cell: (info) => info.getValue(),
        //   size: 180,
        // }),
        // columnHelper.accessor("type", {
        //   header: "Type",
        //   cell: (info) => info.getValue(),
        //   size: 120,
        // }),
        columnHelper.accessor("status", {
          header: "Status",
          cell: (info) => {
            const value = info.getValue();
            return value ? (
              <Badge variant="light" color={getStatusColor(value)}>
                {StudioStatusTypes[value.toUpperCase()].label}
              </Badge>
            ) : (
              ""
            );
          },
          size: 180,
        }),
        // columnHelper.accessor("assignee", {
        //   header: "Assignee",
        //   cell: (info) => info.getValue(),
        //   size: 150,
        // }),
        columnHelper.accessor("deadline", {
          header: "Deadline",
          cell: (info) => info.getValue(),
          size: 150,
        }),
      ],
      masters: [
        columnHelper.accessor("TARGET KEYCODE", {
          header: "Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("BG NUMBER", {
          header: "BG Number",
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor("BG NAME", {
          header: "BG Name",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("DEPT NUMBER", {
          header: "Dept Number",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("DEPT NAME", {
          header: "Dept Name",
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor("CLASS GROUP NUMBER", {
          header: "Class Group Number",
          cell: (info) => info.getValue(),
          size: 220,
        }),
        columnHelper.accessor("CLASS GROUP NAME", {
          header: "Class Group Name",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("MAJOR CLASS NUMBER", {
          header: "Major Class Number",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("MAJOR CLASS NAME", {
          header: "Major Class Name",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("RANGE NUMBER", {
          header: "Range Number",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("RANGE NAME", {
          header: "Range Name",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("STYLE NUMBER", {
          header: "Style Number",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("PRODUCT NAME", {
          header: "Product Name",
          cell: (info) => info.getValue(),
          size: 250,
        }),
        columnHelper.accessor("KMART KEYCODE", {
          header: "Kmart Keycode",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("TARGET KEYCODE", {
          header: "Target Keycode",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("VARIATION", {
          header: "Variation",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("VARIATION SIZE", {
          header: "Variation Size",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("APN", {
          header: "APN",
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor("PRODUCT STATUS", {
          header: "Product Status",
          cell: (info) => info.getValue(),
          size: 200,
        }),
        columnHelper.accessor("COLOUR", {
          header: "Colour",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("BRAND", {
          header: "Brand",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("GBB", {
          header: "GBB",
          cell: (info) => info.getValue(),
          size: 100,
        }),
        columnHelper.accessor("LIFECYCLE", {
          header: "Lifecycle",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("SEASON", {
          header: "Season",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("EVENT", {
          header: "Event",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("OTB", {
          header: "OTB",
          cell: (info) => info.getValue(),
          size: 120,
        }),
      ],
      mastersInfo: [
        // columnHelper.accessor("version", {
        //   header: "Version",
        //   cell: (info) => info.getValue(),
        //   size: 180,
        // }),
        columnHelper.accessor("productStatus", {
          header: "Product Status",
          cell: (info) => info.getValue(),
          size: 150,
        }),
        columnHelper.accessor("styleNumber", {
          header: "Style Number",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("targetKeycode", {
          header: "Target Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("colour", {
          header: "Colour",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("brand", {
          header: "Brand",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("kmartKeycode", {
          header: "Kmart Keycode",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("variation", {
          header: "Variation",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        columnHelper.accessor("dept", {
          header: "Department",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        // columnHelper.accessor("modified", {
        //   header: "Modified",
        //   cell: (info) => info.getValue(),
        //   size: 180,
        // }),
        columnHelper.accessor("variationSize", {
          header: "Variation Size",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("otb", {
          header: "OTB",
          cell: (info) => info.getValue(),
          size: 120,
        }),
        columnHelper.accessor("productName", {
          header: "Product Name",
          cell: (info) => info.getValue(),
          size: 300,
        }),
        columnHelper.accessor("apn", {
          header: "APN",
          cell: (info) => info.getValue(),
          size: 180,
        }),
        // columnHelper.accessor("targetSort", {
        //   header: "Target Sort",
        //   cell: (info) => info.getValue(),
        //   size: 180,
        // }),
      ],
      inventories: buildInventoryColumns(columnHelper, "TAR"),
    },
  };

  return CompanyTableColumns[clientCode][listName];
};

export const CompanyFormats = {
  KMA: {
    LABELS: {
      otbDate: "In-Store Date",
    },
  },
  TAR: {
    LABELS: {
      otbDate: "OTB Date",
    },
  },
  DEFAULT: {
    LABELS: {
      otbDate: "OTB Date",
    },
  },
};

export const StudioStatusTypes = {
  COMPLETE: { value: "COMPLETE", label: "Complete" },
  REVIEW: { value: "REVIEW", label: "Ready for Review" },
  INAPPROVAL: { value: "INAPPROVAL", label: "Ready for Review" },
};

export const CaptureColorSelectionValues = [
  // { label: 'None', value: '', color: 'gray' },
  // { label: 'Red', value: 'red', color: 'red' },
  // { label: 'Green', value: 'green', color: 'green' },
  // { label: 'Blue', value: 'blue', color: 'blue' },
  // { label: 'Yellow', value: 'yellow', color: 'yellow' },
  // { label: 'Purple', value: 'purple', color: 'violet' },
  // { label: 'Orange', value: 'orange', color: 'orange' },
  // { label: 'Pink', value: 'pink', color: 'pink' },
  { label: "None", value: "0", color: "gray" },
  { label: "Red", value: "1", color: "red" },
  { label: "Orange", value: "2", color: "orange" },
  { label: "Yellow", value: "3", color: "yellow" },
  { label: "Green", value: "4", color: "green" },
  { label: "Blue", value: "5", color: "blue" },
  { label: "Pink", value: "6", color: "pink" },
  { label: "Purple", value: "7", color: "violet" },
];

export const MarkupEventTypes = {
  ADD_MARKUP: "addMarkup",
  UPDATE_MARKUP: "updateMarkup",
  DELETE_MARKUP: "deleteMarkup",
  SELECT_MARKUP: "selectMarkup",
  DESELECT_MARKUP: "deselectMarkup",
};
